import { Suspense } from "react";

import { QueryClientProvider } from "@tanstack/react-query";
import { MotionConfig } from "framer-motion";
import { I18nextProvider } from "react-i18next";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";

import { TooltipProvider } from "@/components/ui/tooltip";

import { AuthBootstrap, ThemeProvider } from "@/components/providers";
import { PageLoader } from "@/components/shared";

import i18n from "@/configs/i18n";
import { queryClient } from "@/configs/react-query";
import { router } from "@/router";

const App = () => (
  <QueryClientProvider client={queryClient}>
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        {/* Tizimda "harakatni kamaytirish" yoqilgan bo'lsa, framer-motion
            siljish va masshtabni o'chiradi — faqat shaffoflik qoladi. */}
        <MotionConfig reducedMotion="user">
          <TooltipProvider>
            <AuthBootstrap />

            {/* Sahifalar `lazy` bilan yuklanadi — bu chegara ularning
                hammasini qamrab oladi. */}
            <Suspense fallback={<PageLoader />}>
              <RouterProvider router={router} />
            </Suspense>

            <Toaster richColors position="top-center" closeButton />
          </TooltipProvider>
        </MotionConfig>
      </ThemeProvider>
    </I18nextProvider>
  </QueryClientProvider>
);

export default App;
